import { render, staticRenderFns } from "./ITRQList.vue?vue&type=template&id=153940c2&"
import script from "./ITRQList.vue?vue&type=script&lang=ts&"
export * from "./ITRQList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports